import {
  BiCardView,
  BiDashboardOp,
  BiDashboardOpKind,
  BiDashboardView,
} from '@euler/model/bi/dashboard';
import { useCallback, useMemo } from 'react';
import { biStackedCardIds } from '../../functions/biGridLayout';
import {
  BiCardMove,
  biCardMovePlacement,
  kBiCardMoveTexts,
} from './biCardMove';
import { BiApplyOutcome } from './useBiDashboard';

/**
 * The ⋯ menu's 上移 / 下移 / 移到最前 / 移到最后 (spec §11.3): each is one
 * `place_card` against the order on screen, on the revision on screen, so
 * it is undoable and a stale one is refused like any edit.
 */
export function useBiCardMoves(
  dashboard: BiDashboardView | null,
  apply: (ops: BiDashboardOp[], text: string) => Promise<BiApplyOutcome>,
) {
  const layout = dashboard?.layout;
  const cards = dashboard?.cards;
  // As the grid draws them: an entry without a live card is not shown.
  const order = useMemo(() => {
    if (!layout || !cards) return [];
    const live = new Set(cards.map(card => card.id));
    return biStackedCardIds(layout).filter(id => live.has(id));
  }, [layout, cards]);
  const moveCard = useCallback(
    async (card: BiCardView, move: BiCardMove) => {
      const placement = biCardMovePlacement(order, card.id, move);
      if (!placement) return;
      await apply(
        [{ op: BiDashboardOpKind.PlaceCard, cardId: card.id, placement }],
        `${kBiCardMoveTexts[move]}「${card.title}」`,
      );
    },
    [apply, order],
  );
  return { order, moveCard };
}
